export const RELATIVE_DATE_THRESHOLD = 7; // 7 days
